import { render, staticRenderFns } from "./repairsAndProblems.vue?vue&type=template&id=a8a879e0&scoped=true&"
import script from "./repairsAndProblems.vue?vue&type=script&lang=js&"
export * from "./repairsAndProblems.vue?vue&type=script&lang=js&"
import style0 from "./repairsAndProblems.vue?vue&type=style&index=0&id=a8a879e0&scoped=true&lang=css&"
import style1 from "./repairsAndProblems.vue?vue&type=style&index=1&id=a8a879e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a879e0",
  null
  
)

export default component.exports